import request from "@/utils/request";

const { ElMessage } = require("element-plus");
import { Plus } from "@element-plus/icons-vue";

export default {
  name: "Materiel",
  components: {},
  data() {
    // 手机号验证
    const checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    const actionUrl = process.env.VUE_APP_BASE_URL + "/common/upload";
    return {
      actionUrl: actionUrl,
      loading: true,
      disabled: false,
      judge: false,
      dialogVisible: false,
      search: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      detail: {},
      form: {},
      rules: {
        visitorName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            pattern: /^(?:[\u4E00-\u9FA5·]{2,10})$/,
            message: "必须由 2 到 10 个汉字组成",
            trigger: "blur",
          },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        phoneNum: [{ required: true, validator: checkPhone, trigger: "blur" }],
        visitTime: [
          { required: true, message: "请选择时间", trigger: "change" },
        ],
        content: [
          { required: true, message: "请输入来访信息", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.load();
    this.loading = true;
    setTimeout(() => {
      //设置延迟执行
      this.loading = false;
    }, 1000);
  },
  methods: {
    async load() {
      request
        .get("/material/find", {
          params: {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            search: this.search,
          },
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.loading = false;
        });
    },
    reset() {
      this.search = "";
      request
        .get("/material/find", {
          params: {
            pageNum: 1,
            pageSize: this.pageSize,
            search: this.search,
          },
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.loading = false;
        });
    },
    filterTag(value, row) {
      return row.gender === value;
    },
    showDetail(row) {
      this.detailDialog = true;
      this.$nextTick(() => {
        this.detail = row;
      });
    },
    closeDetailDialog() {
      this.detailDialog = false;
    },
    add() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.disabled = false;
        this.form = {
          count: 1,
        };
        this.judge = false;
      });
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.judge === false) {
            //新增
            await request.post("/material/add", this.form).then((res) => {
              console.log(res);
              if (res.code === "0") {
                ElMessage({
                  message: "新增成功",
                  type: "success",
                });
                this.search = "";
                this.load();
                this.dialogVisible = false;
              } else {
                ElMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            });
          } else {
            //修改
            await request
              .post("/material/update", {
                id: this.form.id,
                count: this.form.count,
                name: this.form.name,
                image: this.form.image,
              })
              .then((res) => {
                console.log(res);
                if (res.code === "0") {
                  ElMessage({
                    message: "修改成功",
                    type: "success",
                  });
                  this.search = "";
                  this.load();
                  this.dialogVisible = false;
                } else {
                  ElMessage({
                    message: res.msg,
                    type: "error",
                  });
                }
              });
          }
        }
      });
    },
    cancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    handleEdit(row) {
      //修改
      this.judge = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        // 生拷贝
        this.form = JSON.parse(JSON.stringify(row));
        this.disabled = true;
      });
    },
    async handleDelete(id) {
      console.log(id);
      request.delete("/material/delete/" + id).then((res) => {
        if (res.code === "0") {
          ElMessage({
            message: "删除成功",
            type: "success",
          });
          this.search = "";
          this.load();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    handleSizeChange(pageSize) {
      //改变每页个数
      this.pageSize = pageSize;
      this.load();
    },
    handleCurrentChange(pageNum) {
      //改变页码
      this.currentPage = pageNum;
      this.load();
    },

    //中国标准时间转换为标准时间
    formatDate(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let dt = new Date(data);
      var y = dt.getFullYear();
      var m = dt.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = dt.getDate();
      d = d < 10 ? "0" + d : d;
      var h = dt.getHours();
      var minute = dt.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = dt.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    handleAvatarSuccess(response, uploadFile) {
      this.form.image = response.data;
    },
    beforeAvatarUpload(rawFile) {
        console.log(rawFile);
      if (rawFile.type !== "image/jpeg"&&rawFile.type !== "image/png") {
        ElMessage.error("头像图片必须是JPG/PNG格式！");
        return false;
      } else if (rawFile.size / 1024 / 1024 > 4) {
        ElMessage.error("头像图片大小不能超过4MB！");
        return false;
      }
      return true;
    },
  },
};
